<template>
  <div style="background-color: #efefef">
    <div class="soluRightBtn">
      <span style="color: #808080">当前位置：</span>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/association' }"
          >水泵协会</el-breadcrumb-item
        >
        <el-breadcrumb-item>会员单位</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="soluBottom">
      <div class="suluBottomBig" v-if="!showNoNews">
        <div
          class="soluBottomRList"
          v-for="(items, index) in solutionList"
          :key="index"
          @click="getNewsItemDetail(items.linkUrl)"
        >
          <div class="soluBottomRImg">
            <img :src="items.thumbnailPath" alt="" />
            <p>{{ items.name }}</p>
          </div>
        </div>
      </div>
      <div v-if="showNoNews" class="suluBottomBig2">
        <!-- 暂无数据 -->
        <img src="../../assets/noMesge.jpg" style="width: 200px" />
      </div>
      <!-- 分页 -->
      <div class="pageina" v-if="!showNoNews">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="current"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="prev, pager, next"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
  
  <script>
import { queryNewText } from "../../utils/interface";
import { mapState } from "vuex";
// 协会会员列表
import { memberProTable } from "../../utils/associationApi";
export default {
  //   新闻
  name: "news",
  metaInfo: {
    title: "水泵云--水泵协会会员单位", // set a title
    // meta: [
    //   {
    //     // set meta
    //     name: "keywords",
    //     content:
    //       "水泵打印|水泵制造|水泵打印行业资讯|水泵打印新闻|水泵打印政策|水泵打印行业数据|水泵打印技术|水泵云|水泵制造行业政策|树脂水泵打印|金属水泵打印|生物水泵打印|智能制造",
    //   },
    //   {
    //     // set meta
    //     name: "description",
    //     content:
    //       "水泵云，每日精选水泵打印业内重点新闻，及时传递价值讯息。水泵云是安徽水泵云数字科技有限公司打造的水泵制造领域综合性工业互联网平台。聚合水泵打印产业链六大资源，水泵模型资源、设计师资源、生产制造资源、产品资源、课程资源、软件资源。并提供四大解决方案：智能制造标准体系的智能工厂解决方案、基于标识解析体系的远程运维解决方案、基于C2M模式的水泵打印个性化定制解决方案、水泵制造行业企业数字化解决方案。",
    //   },
    // ],
  },
  components: {},
  data() {
    return {
      showNoNews: false,
      imgHeightsetIn: null,
      solutionList: [],
      // 分页
      current: 1,
      pageSize: 25,
      total: 0,
      programUuid: "",
      status: "PUBLISH",
      title: "",
      timer: null,
      setIn: null, // 定时器
    };
  },
  watch: {
    title() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.getSolutionList();
      }, 100);
    },
  },
  created() {
    this.setIn = setInterval(() => {
      if (this.isTokenDoor === true) {
        clearInterval(this.setIn);
        this.getSolutionList();
      }
    }, 500);
  },
  computed: {
    ...mapState({
      isTokenDoor: "isTokenDoor",
    }),
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.getSolutionList();
    },
    handleCurrentChange(val) {
      this.current = val;
      window.scrollTo(0, 0);
      this.getSolutionList();
    },
    getSolutionList() {
      let params = {
        current: this.current,
        pageSize: this.pageSize,
      };
      memberProTable(params).then((res) => {
        if (res.success) {
          this.solutionList = res.data;
          this.total = res.total;
          if (this.total > 0) {
            this.showNoNews = false;
          } else {
            this.showNoNews = true;
          }
        } else {
          this.showNoNews = true;
        }
      });
    },
    getNewsItemDetail(linkUrl) {
      if (linkUrl) {
        window.open(linkUrl, "_blank");
      }
    },
  },
};
</script>
  
  <style scoped lang="less">
.soluRightBtn {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
  font-size: 14px;
  color: #6e6e6e;
  display: flex;
  align-items: center;
  font-weight: 400;
}
.soluBottom {
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 40px;

  .suluBottomBig2 {
    text-align: center;
  }
  .suluBottomBig {
    padding-top: 15px;
    display: grid;
    grid-template-columns: 227px 227px 227px 227px 227px;
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    .soluBottomRList {
      cursor: pointer;

      .soluBottomRImg {
        width: 227px;
        height: 108px;
        margin-right: 40px;
        flex-shrink: 0;
        position: relative;
        img {
          width: 100%;
          height: 100%;
          display: block;
        }
        p {
          position: absolute;
          bottom: 0;
          background-color: #099;
          font-size: 12px;
          color: #fff;
          width: 100%;
          padding: 3px;
          box-sizing: border-box;
          text-align: center;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          -o-text-overflow: ellipsis;
        }
      }
    }
  }
  .pageina {
    margin-top: 74px;
    text-align: center;
    margin-right: 20px;
    /deep/.el-pagination button:disabled {
      background-color: transparent;
      border: 1px solid #efefef;
      border-radius: 5px;
    }
    /deep/.el-pagination .btn-prev {
      padding-right: 0;
    }
    /deep/.el-pager li {
      border: 1px solid #efefef;
      border-radius: 5px;
      margin: 0 5px;
    }
    /deep/.el-pager li.active {
      border: 1px solid #009999;
      color: #009999;
    }
  }
}
</style>
  


// WEBPACK FOOTER //
// src/components/association/member.vue